"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputOtp = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const inputtext_1 = require("primereact/inputtext");
const utils_1 = require("primereact/utils");
const react_1 = require("react");
const InputOtp = ({ length = 6, mask = false, value = '', onChange, disabled = false, invalid = false, autoFocus = false, integerOnly = true, className, inputClassName, placeholder = '', }) => {
    const [otpValues, setOtpValues] = (0, react_1.useState)(Array(length).fill(''));
    const inputRefs = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        if (value) {
            const valueArray = value.split('').slice(0, length);
            const newValues = Array(length).fill('');
            valueArray.forEach((char, index) => {
                newValues[index] = char;
            });
            setOtpValues(newValues);
        }
        else {
            setOtpValues(Array(length).fill(''));
        }
    }, [value, length]);
    (0, react_1.useEffect)(() => {
        if (autoFocus && inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, [autoFocus]);
    const focusInput = (index) => {
        if (index >= 0 && index < length && inputRefs.current[index]) {
            inputRefs.current[index]?.focus();
            inputRefs.current[index]?.select();
        }
    };
    const updateValue = (newValues) => {
        setOtpValues(newValues);
        onChange?.(newValues.join(''));
    };
    const isValidInput = (char) => {
        if (integerOnly) {
            return /^\d$/.test(char);
        }
        return /^[a-zA-Z0-9]$/.test(char);
    };
    const handleChange = (e, index) => {
        const inputValue = e.target.value;
        if (inputValue.length > 1) {
            const chars = inputValue.split('').filter(isValidInput);
            if (chars.length > 0) {
                const newValues = [...otpValues];
                chars.forEach((char, i) => {
                    if (index + i < length) {
                        newValues[index + i] = char;
                    }
                });
                updateValue(newValues);
                const nextIndex = Math.min(index + chars.length, length - 1);
                focusInput(nextIndex);
            }
            return;
        }
        if (inputValue === '' || isValidInput(inputValue)) {
            const newValues = [...otpValues];
            newValues[index] = inputValue;
            updateValue(newValues);
            if (inputValue && index < length - 1) {
                focusInput(index + 1);
            }
        }
    };
    const handleKeyDown = (e, index) => {
        switch (e.key) {
            case 'Backspace':
                if (!otpValues[index] && index > 0) {
                    e.preventDefault();
                    const newValues = [...otpValues];
                    newValues[index - 1] = '';
                    updateValue(newValues);
                    focusInput(index - 1);
                }
                break;
            case 'Delete':
                if (!otpValues[index] && index < length - 1) {
                    const newValues = [...otpValues];
                    newValues[index + 1] = '';
                    updateValue(newValues);
                }
                break;
            case 'ArrowLeft':
                e.preventDefault();
                focusInput(index - 1);
                break;
            case 'ArrowRight':
                e.preventDefault();
                focusInput(index + 1);
                break;
            case 'Home':
                e.preventDefault();
                focusInput(0);
                break;
            case 'End':
                e.preventDefault();
                focusInput(length - 1);
                break;
        }
    };
    const handlePaste = (e, index) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text');
        const chars = pastedData.split('').filter(isValidInput);
        if (chars.length > 0) {
            const newValues = [...otpValues];
            chars.forEach((char, i) => {
                if (index + i < length) {
                    newValues[index + i] = char;
                }
            });
            updateValue(newValues);
            const nextIndex = Math.min(index + chars.length, length - 1);
            focusInput(nextIndex);
        }
    };
    const handleFocus = (e) => {
        e.target.select();
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, utils_1.classNames)('flex gap-7px', className), children: Array.from({ length }).map((_, index) => ((0, jsx_runtime_1.jsx)(inputtext_1.InputText, { ref: (el) => {
                inputRefs.current[index] = el;
            }, type: mask ? 'password' : 'text', inputMode: integerOnly ? 'numeric' : 'text', value: otpValues[index], onChange: (e) => handleChange(e, index), onKeyDown: (e) => handleKeyDown(e, index), onPaste: (e) => handlePaste(e, index), onFocus: handleFocus, disabled: disabled, maxLength: length, autoComplete: 'one-time-code', style: { aspectRatio: '1' }, className: (0, utils_1.classNames)('flex-1 min-w-0px max-w-48px max-h-48px p-0 text-center text-title-lg-med', {
                'border-red-100': invalid,
                'text-gray-100': !disabled,
                'text-gray-40': disabled,
            }, inputClassName), placeholder: placeholder }, index))) }));
};
exports.InputOtp = InputOtp;
